/*
 * Sticky add to cart bar: shows when the real add to cart button is above the viewport.
 * Pressing it scrolls to the real button and presses it, so required options are still validated.
 */
(() => {
  function init(bar) {
    if (bar.dataset.ready) return;
    bar.dataset.ready = 'true';

    const sectionId = bar.dataset.sectionId;
    const submit = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const button = bar.querySelector('[data-sticky-button]');
    const priceTarget = bar.querySelector('[data-sticky-price]');
    if (!submit || !button) return;

    const setVisible = (visible) => {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', String(!visible));
      button.tabIndex = visible ? 0 : -1;
    };

    // Visible only after the real button has scrolled past the top of the screen.
    new IntersectionObserver(
      ([entry]) => setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0),
      { threshold: 0 }
    ).observe(submit);

    button.addEventListener('click', () => {
      if (submit.disabled || submit.getAttribute('aria-disabled') === 'true') return;
      submit.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => submit.click(), 450);
    });

    // Keep the price in sync with the selected variant.
    const priceBox = document.getElementById(`price-${sectionId}`);
    if (priceBox && priceTarget) {
      const sync = () => {
        const current = priceBox.querySelector('.price-item--last, .price-item--sale, .price-item--regular');
        if (current) priceTarget.textContent = current.textContent.trim();
      };
      new MutationObserver(sync).observe(priceBox, { childList: true, subtree: true, characterData: true });
      sync();
    }

    // Keep the label in sync (sold out / unavailable variants).
    const label = submit.querySelector('span');
    if (label) {
      const syncLabel = () => {
        button.textContent = label.textContent.trim();
        button.disabled = submit.disabled;
      };
      new MutationObserver(syncLabel).observe(submit, { attributes: true, childList: true, subtree: true });
      syncLabel();
    }
  }

  const initAll = () => document.querySelectorAll('[data-product-sticky-atc]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
